
import React from 'react';
import FormInput from '../FormInput';
import { PoliticalAndStrategic } from '../../types';

interface PoliticalStrategicFormProps {
  data: PoliticalAndStrategic;
  onChange: (field: string, value: string) => void;
}

const PoliticalStrategicForm: React.FC<PoliticalStrategicFormProps> = ({
  data,
  onChange
}) => {
  return (
    <div className="animate-fade-in">
      <h3 className="text-lg font-medium mb-4">Political & Strategic Analysis</h3>
      
      <FormInput
        id="government_motivations"
        label="Known or Suspected Government/Political Motivations"
        placeholder="Describe political interests driving their position on this issue"
        value={data.government_motivations}
        onChange={(e) => onChange('government_motivations', e.target.value)}
        multiline
        rows={3}
      />
      
      <FormInput
        id="opposition_tactics"
        label="Opposition Tactics or Counter-Campaign Strategy"
        placeholder="e.g., industry lobbying, opposition messaging, political pressure"
        value={data.opposition_tactics}
        onChange={(e) => onChange('opposition_tactics', e.target.value)}
        multiline
        rows={3}
      />
      
      <FormInput
        id="political_vulnerabilities"
        label="Known Political Vulnerabilities or Pressure Points"
        placeholder="Describe electoral risks, policy contradictions, or stakeholder pressures"
        value={data.political_vulnerabilities}
        onChange={(e) => onChange('political_vulnerabilities', e.target.value)}
        multiline
        rows={3}
      />
      
      <FormInput
        id="coalition_opportunities"
        label="Coalition Building and Alliance Opportunities"
        placeholder="Describe potential partners, shared interests, and coalition possibilities"
        value={data.coalition_opportunities}
        onChange={(e) => onChange('coalition_opportunities', e.target.value)}
        multiline
        rows={3}
      />
    </div>
  );
};

export default PoliticalStrategicForm;
